/**
 * Vote display rules of the Cassiopeia campaign.
 *
 * A project's vote count is only public once the voting stage has started; before that the pages
 * render a placeholder instead of a zero.
 */
/**
 * Votes to display for a project.
 *
 * @param votes  Stored vote count; `null`/`undefined` when unknown.
 * @param phases Processed phases of the campaign.
 * @returns The vote count once voting started, otherwise `-1` as the "not public" marker.
 */
export const determineVotes = (votes, phases) => {
    let returnedVotes = -1;
    const isStarted = phases?.voteStarted ?? phases?.votingStarted;
    if (votes != null && isStarted) {
        returnedVotes = votes;
    }
    return returnedVotes;
};
//# sourceMappingURL=votes.js.map